import { render, staticRenderFns } from "./CategoriesDGII.vue?vue&type=template&id=53376438"
import script from "./CategoriesDGII.vue?vue&type=script&lang=js"
export * from "./CategoriesDGII.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports